<template>
  <div class="introduction-process">
    <h3>{{title}}</h3>
    <ul v-if="list && list.length > 0">
      <li v-for="(item, index) in list" :key="item">
        <span class="introduction-process-no">{{index + 1}}</span>
        {{item}}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '招募流程'
    },
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.introduction-process {
  margin-bottom: 20px;
  padding: 40px 60px;
  line-height: 1;
  background-color: #fff;
  color: $ucar_font_color;

  h3 {
    text-align: center;
    margin-bottom: 40px;
    font-size: $ucar_font_h4;
    font-weight: bold;
  }

  ul {
    position: relative;
    padding-left: 70px;

    li {
      position: relative;
      height: 36px;
      line-height: 36px;
      font-size: $ucar_font_h6;
      margin-bottom: 30px;

      span.introduction-process-no {
        overflow: visible;
        box-sizing: border-box;
        width: 36px;
        height: 36px;
        font-size: 28px;
        position: absolute;
        left: -70px;
        top: 0;
        border: 1px solid hsla(34, 59%, 70%, 1); /*no*/
        color: $ucar_price_color;
        border-radius: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
      }

      &:first-child {
        span.introduction-process-no::before {
          content: none;
        }
      }
    }

    &::before {
      position: absolute;
      content: '';
      width: 1px; /*no*/
      top: 0;
      left: 18px;
      height: 98%;
      background-color: hsla(34, 59%, 70%, 1);
    }
  }
}
</style>
